function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Radio, Alert, Table, Form } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MedicalReport = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;

  //console.log(JSON.stringify(customer));     
  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  useEffect(function () {
    form.setFieldsValue({
      conclusion: candidat.conclusion.conclusion
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        children: [/*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 4,
            children: /*#__PURE__*/_jsx("img", {
              src: "drawables/mvc.jpeg",
              style: {
                width: '90%'
              }
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 4,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                padding: "8px",
                color: "#EEE",
                background: "#168794",
                clear: "both"
              },
              children: [/*#__PURE__*/_jsx("h2", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "RAPPORT MEDICAL"
                })
              }), /*#__PURE__*/_jsxs("span", {
                children: ["N\xBA RP", candidat.candidate_code]
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs("div", {
              className: "pad cool-radius",
              children: [/*#__PURE__*/_jsxs("p", {
                style: {
                  fontSize: "16px"
                },
                children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "INFOS PATIENT"
                  }),
                  bordered: true,
                  column: 1,
                  size: "small",
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "NOM COMPLET"
                    }),
                    children: candidat.name
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "\xC2GE"
                    }),
                    children: [moment(candidat.birthdate).diff(moment(), 'years') * -1, " ans. "]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "POSTE DE TRAVAIL"
                    }),
                    children: candidat.job
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MATRICULE"
                    }),
                    children: candidat.matricule
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "LIEU DE RESIDENCE"
                    }),
                    children: candidat.address
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "ENTREPRISE"
                    }),
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsx("br", {})]
              }), /*#__PURE__*/_jsxs("p", {
                children: [/*#__PURE__*/_jsx("h4", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "ETAT GENERAL"
                  })
                }), candidat.conclusion.mr_general_state]
              }), /*#__PURE__*/_jsx(Divider, {}), candidat.medecine_questions != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "CONSTANTES"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Poids"
                  }),
                  children: [candidat.medecine_questions.weight, " "]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Tension"
                  }),
                  children: candidat.medecine_questions.ta
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "TAILLE"
                  }),
                  children: candidat.medecine_questions.tallness
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "FREQ. CARDIAQUE"
                  }),
                  children: candidat.medecine_questions.fc
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "FREQ. RESPIRATOIRE"
                  }),
                  children: candidat.medecine_questions.fr
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "TEMPERATURE"
                  }),
                  children: candidat.medecine_questions.temperature
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.visio_test != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "VISIO TEST"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "BINOCULAIRE (VISION DE PRES)"
                  }),
                  children: [candidat.visio_test.binocular, " "]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "BINOCULAIRE (VISION DE LOIN)"
                  }),
                  children: [candidat.visio_test.f_binocular, " "]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "DROIT (VISION DE PRES)"
                  }),
                  children: candidat.visio_test.rightsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "DROIT (VISION DE LOIN)"
                  }),
                  children: candidat.visio_test.f_rightsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "GAUCHE (VISION DE PRES)"
                  }),
                  children: candidat.visio_test.leftsight
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "GAUCHE (VISION DE LOIN)"
                  }),
                  children: candidat.visio_test.f_leftsight
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.audio_test != null && /*#__PURE__*/_jsxs(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "AUDIO TESTE"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CA GAUCHE"
                  }),
                  children: [candidat.audio_test.hcleft, " "]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CA DROIT"
                  }),
                  children: candidat.audio_test.hcright
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.spirometrie != null && /*#__PURE__*/_jsx(Descriptions, {
                title: /*#__PURE__*/_jsx("b", {
                  children: "SPIROMETRIE"
                }),
                bordered: true,
                column: 2,
                size: "small",
                children: /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ETAT"
                  }),
                  children: [candidat.spirometrie.status == 0 ? "ANORMAL" : "NORMAL", " "]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx("p", {
                  children: candidat.conclusion.mr_conclusion != null && /*#__PURE__*/_jsx(Alert, {
                    type: "info",
                    banner: true,
                    message: /*#__PURE__*/_jsx("b", {
                      children: "CONCLUSION"
                    }),
                    showIcon: false,
                    description: candidat.conclusion.mr_conclusion
                  })
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
                type: "info",
                banner: true,
                message: /*#__PURE__*/_jsx("b", {
                  children: "RECOMMANDATION"
                }),
                showIcon: false,
                description: candidat.conclusion.mr_recommandation != null && candidat.conclusion.mr_recommandation != "undefined" && candidat.conclusion.mr_recommandation != "null" && /*#__PURE__*/_jsx("b", {
                  children: candidat.conclusion.mr_recommandation
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Conakry, le "
                }), /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY"
                })]
              }), /*#__PURE__*/_jsx("br", {})]
            })
          })
        }), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Le M\xE9decin"
                })
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
          type: "info",
          message: /*#__PURE__*/_jsx("b", {}),
          description: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
              children: ["Adresse: Prima Center, Commune de Ratoma, Conakry, R\xE9p. de Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                children: "Tel: +224 621 72 49 21 - E-mail: info@medviegn.com"
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default MedicalReport;